var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPragmetic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98629 6.00413C7.21129 6.09897 8.01004 8.10259 9.96937 7.99589C11.8877 7.89511 10.8773 5.89742 8.98629 6.00413Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5C4.46053 5 2 7.46053 2 10.5C2 13.5395 4.46053 16 7.5 16C10.5395 16 13 13.5395 13 10.5C13 7.46053 10.5395 5 7.5 5ZM7.5 15.4276C4.7829 15.4276 2.57895 13.2237 2.57895 10.5066C2.57895 7.78947 4.7829 5.58553 7.5 5.58553C10.2171 5.58553 12.4211 7.78947 12.4211 10.5066C12.4211 13.2237 10.2171 15.4276 7.5 15.4276Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.932983C6.66083 1.91853 6.89637 3.4297 6.89637 3.4297C6.89637 3.4297 6.05518 1.30092 4.96501 0C4.81696 1.67543 5.35532 3.89619 5.35532 3.89619C5.35532 3.89619 4.67564 2.523 3 2.44415C4.38627 3.22602 4.92463 4.62549 5.04576 5C5.84657 4.5138 6.78869 4.2247 7.79139 4.19185C7.68371 3.84363 7.29341 2.36531 8 0.932983Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47249 10.8359V12H4V9H4.99029C5.32686 9 5.57929 9.07982 5.74757 9.24612C5.91586 9.41242 6 9.63858 6 9.92461C6 10.2106 5.91586 10.4302 5.7411 10.5965C5.56634 10.7627 5.31392 10.8426 4.99029 10.8426H4.47249V10.8359ZM5.52751 9.91796C5.52751 9.74501 5.4822 9.61863 5.39159 9.53215C5.30097 9.44568 5.1521 9.39911 4.94498 9.39911H4.47249V10.4368H4.94498C5.33333 10.4368 5.52751 10.2639 5.52751 9.91796Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63755 11.6208H8V12H6V9H6.63755V11.6208Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1831 11.3378H8.80964L8.56386 12H8L9.2 9H9.80723L11 12H10.4361L10.1904 11.3378H10.1831ZM10.0386 10.9595L9.49639 9.53378L8.95422 10.9595H10.0313H10.0386Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9L11.1979 10.9091V12H10.8075V10.9091L10 9H10.4492L11 10.3902L11.5508 9H11.9947H12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPragmetic);
export default __webpack_public_path__ + "static/media/pragmetic.5cf8f1a619603cab38d4d1b1b6fa78d9.svg";
export { ForwardRef as ReactComponent };